import React from 'react'
import PropTypes from 'prop-types'
import { sanitizeDom } from '../../../utils'
import { useFeatureFlags } from '../../../hooks/useFeatureFlags'
import { usePlanChangeFlag } from '../../../hooks/usePlanChange'
import EmailBox from '../../shared/emailBox'
import styles from './guest-content-cta-box.css'
import { useConfig } from '../../../hooks/use-config'
import { getConfigValue } from '../../../utils/getConfigValue'
// used when there is no discount
const GENERIC = {
  header: 'Binge the best',
  desc: 'Watch the latest TV shows, movies, and all your favourites.'
}

const GuestContentCTABox = () => {
  const flags = useFeatureFlags(['discount_basic', 'discount_standard', 'discount_annual'])
  const showBasicDiscount = flags.discount_basic
  const showStandardDiscount = flags.discount_standard
  const showAnnualDiscount = flags.discount_annual
  const isShowingDiscount = (showBasicDiscount || showStandardDiscount || showAnnualDiscount)
  const { appConfig } = useConfig()
  const discountTermsLink = getConfigValue(appConfig.values, 'DISCOUNT_TERMS_LINK')
  const planDetails = usePlanChangeFlag()
  /**
   * when there is no discount, plan will be basic
   * when there is discount, this will be the plan that's on discount
   * there should be only one plan that has discount at a time
   */
  let plan = planDetails.basic
  if (showAnnualDiscount) {
    plan = planDetails.annual
  }
  if (showStandardDiscount) {
    plan = planDetails.standard
  }
  if (showBasicDiscount) {
    plan = planDetails.basic
  }
  const line1 = isShowingDiscount ? plan.discountGuestHotspotHeader : GENERIC.header
  const line2 = isShowingDiscount ? plan.discountGuestHotspotDesc(discountTermsLink) : GENERIC.desc

  const [priceBeforeDot, priceAfterDot] = isShowingDiscount ? plan.discountPrice?.split('.') : plan.price.split('.')

  return (
    <div className={styles.wrapper}>
      {/** line1 - header  */}
      <div className={styles.title}>{line1}</div>
      {/** line2 - desc */}
      <div
        className={styles.synopsis}
        dangerouslySetInnerHTML={{ __html: sanitizeDom(line2) }}
      />
      {/** line3 - crossed-out price or just "From" */}
      <div className={styles.priceInfo}>
        {isShowingDiscount ? (
          <div className={styles.originalPrice}>
            &nbsp;$
            {plan.price}
            {plan.unit}
            &nbsp;
          </div>
        ) : (
          <div>From</div>
        )}
      </div>
      {/** line4 - the big price */}
      <div className={styles.priceAmount}>
        <span className={styles.currency}>$</span>
        <span className={styles.priceAmountBeforeDot}>{priceBeforeDot}</span>
        <div className={styles.priceAmountRightFrame}>
          <span className={styles.priceAmountAfterDot}>{priceAfterDot}</span>
          <span className={styles.priceAmountUnit}>{plan.unit}</span>
        </div>
      </div>
      <EmailBox buttonText="GET STARTED" inputText="Email" />
    </div>
  )
}

GuestContentCTABox.propTypes = {
  guestHeroContent: PropTypes.shape({
    line1: PropTypes.string,
    line2: PropTypes.string,
    msgForBasicDiscount: PropTypes.string,
    msgForStandardDiscount: PropTypes.string,
    msgForAnnualDiscount: PropTypes.string
  }).isRequired
}

export default GuestContentCTABox
